var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgPreview"},[_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"src":_vm.img,"stencil-props":_vm.stencilProps,"backgroundClass":"white"},on:{"ready":_vm.ready,"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }